import type { RefObject } from 'react';
import { useEffect, useState } from 'react';

export function useContainerQuery(ref: RefObject<HTMLElement | null>, query: number): boolean {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        const width = entry.contentRect.width;
        setMatches(width >= query);
      }
    });

    resizeObserver.observe(element);

    // Initial check
    const width = element.getBoundingClientRect().width;
    setMatches(width >= query);

    return () => {
      resizeObserver.disconnect();
    };
  }, [ref, query]);

  return matches;
}
